module.exports = __webpack_public_path__ + "static/media/nuage2.12f8852a.png";